var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAmex = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.4382 34.8889L39.583 32.7111L37.6537 34.8889H33.8693H25.7067V24.8556H21.8481L26.5972 13.5778H31.1979L32.8304 17.4667V13.5778H38.5442L39.5088 16.5333L40.4735 13.5778H44.8516V11.8667C44.8516 10.8556 44.0353 10 43.0707 10H4.78092C3.81625 10 3 10.8556 3 11.8667V36.1333C3 37.1444 3.81625 38 4.78092 38H43.1449C44.1095 38 44.9258 37.1444 44.9258 36.1333V34.8889H41.4382Z",
    fill: "#0071CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9578 33.7222H44.926L40.9931 29.2889L44.926 25.0111H42.032L39.509 27.8111L37.1344 25.0111H34.092L38.0249 29.3667L34.092 33.7222H36.986L39.509 30.9222L41.9578 33.7222Z",
    fill: "#0071CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2686 31.7V30.3778H33.9435V28.3556H29.2686V27.0333H34.0919V25.0111H26.9683V33.7222H34.0919V31.7H29.2686Z",
    fill: "#0071CE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6998 23.6889H44.926V14.9L41.4383 14.9778L39.5832 20.4222L37.6539 14.9778H34.092V23.6889H36.3924V17.5445L38.5443 23.6889H40.5479L42.6998 17.5445V23.6889Z",
    fill: "#0071CE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3816 14.9778H27.4134L23.7031 23.7667H26.2261L26.8939 21.9778H30.7526L31.4946 23.7667H34.0918L30.3816 14.9778ZM27.7102 19.9556L28.8233 17.0778L29.9363 19.9556H27.7102Z",
    fill: "#0071CE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8481 29.0555L44.9259 31.4666L45.0001 26.6444L42.8481 29.0555Z",
    fill: "#0071CE"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAmex);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/amex.d752b494332cec31865a21b861c97e7c.svg";